import SVTAPI from './svtapi';

class Deliveries extends SVTAPI {
  constructor() {
    super('/deliveries');
  }

  /**
   * GET /deliveries
   * Gets a list of deliveries.
   *
   * @param   {Object} filters Filter results e.g. by client.
   * @returns {Object}         The server's response
   */
  get(filters) {
    return super.get({ data: filters });
  }

  /**
   * POST /deliveries
   * Create new delivery.
   *
   * @param   {Object} data The delivery data.
   * @returns {Object}      The server's response
   */
  post(data) {
    return super.post({ data });
  }
}

export default new Deliveries();
